/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationResponse } from './NotificationResponse';
import {
    NotificationResponseFromJSON,
    NotificationResponseFromJSONTyped,
    NotificationResponseToJSON,
    NotificationResponseToJSONTyped,
} from './NotificationResponse';

/**
 * 
 * @export
 * @interface GetNotificationsResponse
 */
export interface GetNotificationsResponse {
    /**
     * 
     * @type {Array<NotificationResponse>}
     * @memberof GetNotificationsResponse
     */
    notifications: Array<NotificationResponse>;
    /**
     * Total count of non-dismissed notifications
     * @type {number}
     * @memberof GetNotificationsResponse
     */
    total: number;
    /**
     * Whether there are more notifications to load
     * @type {boolean}
     * @memberof GetNotificationsResponse
     */
    hasMore: boolean;
}

/**
 * Check if a given object implements the GetNotificationsResponse interface.
 */
export function instanceOfGetNotificationsResponse(value: object): value is GetNotificationsResponse {
    if (!('notifications' in value) || value['notifications'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('hasMore' in value) || value['hasMore'] === undefined) return false;
    return true;
}

export function GetNotificationsResponseFromJSON(json: any): GetNotificationsResponse {
    return GetNotificationsResponseFromJSONTyped(json, false);
}

export function GetNotificationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNotificationsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'notifications': ((json['notifications'] as Array<any>).map(NotificationResponseFromJSON)),
        'total': json['total'],
        'hasMore': json['hasMore'],
    };
}

export function GetNotificationsResponseToJSON(json: any): GetNotificationsResponse {
    return GetNotificationsResponseToJSONTyped(json, false);
}

export function GetNotificationsResponseToJSONTyped(value?: GetNotificationsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'notifications': ((value['notifications'] as Array<any>).map(NotificationResponseToJSON)),
        'total': value['total'],
        'hasMore': value['hasMore'],
    };
}

